import { Log } from 'oidc-client-ts';

import { AuthLogger } from './logger';

export function isDebug() {
    return window.localStorage.getItem('AUTH_DEBUG') === 'true';
}

export function setDebuggingLogger() {
    Log.setLogger(AuthLogger.getInstance());
    Log.setLevel(Log.DEBUG);
}
